import { render, staticRenderFns } from "./teamConfig.vue?vue&type=template&id=62bc2cb8&"
import script from "./teamConfig.vue?vue&type=script&lang=js&"
export * from "./teamConfig.vue?vue&type=script&lang=js&"
import style0 from "./teamConfig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports